module.exports = __webpack_public_path__ + "assets/grotesk-webfont-6ea8cbab1d1ad8ca76c384030497f127.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/font/grotesk-webfont.eot
// module id = 388
// module chunks = 1